/**
 * Hero product film carousel — each slide is a real SprintFit YouTube film with explicit recovery positioning.
 * Re-order or add IDs when new product films ship.
 */
export const HERO_VIDEO_CAROUSEL_SLIDES = [
  {
    videoId: 'i6Sk279Nx-Q',
    shortLabel: 'Overview',
    title: 'ThermaCube — overview',
    product: 'ThermaCube',
    modality: 'Contrast therapy',
    solve: 'Athletes and desk athletes who need heat, cold, and alternating cycles without a second appliance.',
    replaces: 'Separate ice packs, gel packs, plug-in heating pads, timers, and messy contrast setups.',
  },
  {
    videoId: 'zpQ0Ph0U__Y',
    shortLabel: 'Deep dive',
    title: 'ThermaCube — features walkthrough',
    product: 'ThermaCube',
    modality: 'Heat · cold · contrast',
    solve: 'Anyone tired of guessing temperatures or swapping tools mid-session.',
    replaces: 'The “ice bowl + heating pad + stopwatch” routine and clinic-only contrast demos.',
  },
  {
    videoId: 'uV08hM0q38Q',
    shortLabel: 'Daily use',
    title: 'ThermaCube — everyday use',
    product: 'ThermaCube',
    modality: 'Convenience',
    solve: 'Making recovery portable: sofa, hotel, post-commute—wherever you actually live.',
    replaces: 'Recovery that only happens when you are near a kitchen freezer or microwave.',
  },
  {
    videoId: 'D-dgq1aIvWM',
    shortLabel: 'Quick demo',
    title: 'ThermaCube — quick demo',
    product: 'ThermaCube',
    modality: 'Speed to relief',
    solve: 'Seeing power-on, modes, and noise level before you invest.',
    replaces: 'Blind buys from static photos—watch the unit you will unbox.',
  },
  {
    videoId: '1p7ialq-he8',
    shortLabel: 'Fit',
    title: 'ThermaCube — fit & wear',
    product: 'ThermaCube',
    modality: 'Wearable fit',
    solve: 'Strap tension, placement, and how it sits on knee, thigh, and torso.',
    replaces: 'Guessing if a compact pad will stay put—film shows the real hold.',
  },
];
